import { useNavigate } from "react-router-dom";
import { Button } from "src/components/buttons/shadcn-button";
import AssignCustomerModal from "./AssignCustomerModal";
import { Customer, Member } from "src/redux/types/_customer.type";
import { useState } from "react";

const ActionButtons = ({
  customer,
  members,
}: {
  customer: Customer;
  members: Member[];
}) => {
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);

  const handleClose = () => {
    setIsOpen(!isOpen);
  };

  const name = !customer
    ? "—"
    : [customer.first_name, customer.middle_name, customer.last_name]
        .filter(Boolean)
        .join(" ")
        .trim();

  return (
    <div className="p-3 rounded-xl border mt-3">
      <h1 className="text-md font-medium mb-3">Actions</h1>
      <div className="flex grow justify-evenly gap-4 flex-wrap">
        <Button variant="outline" onClick={() => setIsOpen(!isOpen)}>
          Assign Employee
        </Button>

        {customer.subscription && (
          <>
            <Button
              variant="outline"
              onClick={() =>
                navigate(
                  `/admin/manage-customers/report/${customer.id}/${customer.subscription.id}/${name}`,
                )
              }
            >
              Add Heath Report
            </Button>
            <Button
              variant="outline"
              onClick={() =>
                navigate(
                  `/admin/manage-customers/report/view/${customer.id}/${customer.subscription.id}/${name}`,
                )
              }
            >
              View Health Report
            </Button>
            <Button
              variant="outline"
              onClick={() =>
                navigate(`/admin/manage-customers/counselling/${customer.id}`, {
                  state: { members },
                })
              }
            >
              Add Counselling
            </Button>
            <Button
              variant="outline"
              onClick={() =>
                navigate(
                  `/admin/manage-customers/counselling/view/${customer.id}`,
                  { state: { members } },
                )
              }
            >
              View Counselling
            </Button>
          </>
        )}
      </div>

      <AssignCustomerModal
        customer={customer}
        isOpen={isOpen}
        close={handleClose}
      />
    </div>
  );
};

export default ActionButtons;
